import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';

export const useUpdateServiceCatalog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: serviceCatalogServices.updateServiceCatalog,
    onSuccess: () => {
      queryClient.invalidateQueries(['service-catalog']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update service catalog entry');
    },
  });
};
